import { apiQuery, createQueryKeys, useApiMutation } from '@/shared/data';
import { msg } from '@lingui/core/macro';
import type { FeedbackMessage } from '@/shared/data';
import * as api from './billing.api';
export const billingKeys = createQueryKeys('billing');
export const billingQuery = (id: string) =>
  apiQuery(billingKeys.detail(id), ({ signal }) => api.getBilling(id, signal), {
    enabled: id !== '',
  });
export const billingPixQuery = (id: string, modality?: string | null) =>
  apiQuery(billingKeys.custom('pix', id), ({ signal }) => api.getBillingPix(id, signal), {
    enabled: id !== '' && modality !== 'BoletoApenas',
  });
const mutations = {
  create: api.createBilling,
  workflowPatch: api.patchBillingWorkflow,
  register: api.registerBilling,
  fees: api.cancelBillingFees,
  comment: api.postBillingComment,
  update: api.updateBilling,
  cancel: api.cancelBilling,
  email: api.sendBillingEmail,
  communication: api.updateBillingCommunication,
};
const successMessages: Partial<Record<keyof typeof mutations, FeedbackMessage>> = {
  create: { title: msg`Sucesso`, description: msg`Excelente! Agora você pode editar ou seguir com o cadastro.` },
  register: { title: msg`Cobrança registrada com sucesso!`, description: msg`Aguarde um momento enquanto atualizamos o status. Assim que estiver alterado, o boleto estará disponível para você.` },
  update: { title: msg`Sucesso ao editar cobrança` },
  cancel: { title: msg`Sucessso ao solicitar a baixa da cobrança` },
  email: { title: msg`Sucesso ao enviar e-mail` },
  communication: { title: msg`Régua de comunicação da cobrança atualizada com sucesso` },
  fees: { title: msg`Emolumento cancelado com sucesso` },
};

export function useBillingMutation<K extends keyof typeof mutations>(
  name: K,
  feedback: { readonly success?: FeedbackMessage | false } = {},
) {
  type Input = Parameters<(typeof mutations)[K]>[0];
  const run = mutations[name] as (
    input: Input,
  ) => Promise<Awaited<ReturnType<(typeof mutations)[K]>>>;
  return useApiMutation({
    mutationFn: run,
    mutationKey: ['billing', 'mutation', name],
    invalidate: [billingKeys.all],
    success: feedback.success === undefined ? (successMessages[name] ?? false) : feedback.success,
  });
}
